import { createFileRoute } from "@tanstack/react-router";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import { z } from "zod";
import InvoiceCancelationsTable from "@/components/invoices/cancelations/cancelations-table";

const cancelationsSearchSchema = z.object({
  page: z.number().optional().default(1),
  search: z.string().optional(),
  status: z.string().optional(),
  reason: z.string().optional(),
});

export const Route = createFileRoute(
  "/_authenticated/invoices/cancelations/",
)({
  validateSearch: cancelationsSearchSchema,
  component: InvoicesCancelationsPage,
});

function InvoicesCancelationsPage() {
  const searchParams = Route.useSearch();

  return (
<RouteGuardPermissions
      permissions={[{ module: "invoices_cancelation_requests", actions: ["read"] }]}>
      
    <div className="space-y-4">
      <InvoiceCancelationsTable
        currentPage={searchParams.page}
        basePath="/invoices/cancelations"
        searchParams={searchParams}
      />
    </div>
  
    </RouteGuardPermissions>
  );
}
